/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { rankingAgent } from "@api/Api";

export const getAllRankingAgent = createAsyncThunk(
  "appRankingAgent/getAllRankingAgent",
  async (values) => {
    try {
      return rankingAgent.getAll(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const appRankingAgentSlice = createSlice({
  name: "appRankingAgent",
  initialState: {
    rankingAgent: [],
    rankingAgentFetch: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllRankingAgent.fulfilled, (state, action) => {
      state.rankingAgent = action.payload?.data?.data;
      state.rankingAgentFetch = true;
    });
  },
});

export default appRankingAgentSlice.reducer;
